// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Glk2g","image":"styles_image__khglu","button-wrapper":"styles_button-wrapper__I+7cm"};